/**
 * This is the entry point for specific javascript of theme
 */


console.log('Tre Spade Theme');

document.addEventListener("input", function (e) {
    if (e.target && e.target.id != "ricambi-filter-input") {
        return;
    }

    const filterInputs = document.querySelectorAll("#ricambi-filter-input");
    const listItems = document.querySelectorAll("#FacetFiltersContainer .ricambio-compatibile-con .details__content ul.list li");

    if (filterInputs && filterInputs.length > 0) {
        filterInputs.forEach(filterInput => {
            document.addEventListener("input", function (e) {
                e.preventDefault();
                const filterText = filterInput.value.toLowerCase();

                listItems.forEach(item => {
                    const label = item.querySelector("label").textContent.toLowerCase();
                    if (label.includes(filterText)) {
                        item.style.display = ""; // Mostra elemento
                    } else {
                        item.style.display = "none"; // Nascondi elemento
                    }
                });
            });

        });
    }
});


// WEBPACK FOOTER //
// ./js/theme.js